import React from "react";
import SelectOption from "./components/SelectOption";

const volatileComponentsHandlingOptions = [
  {
    value: "notRequired",
    label: "揮発処理不要",
  },
  {
    value: "required",
    label: "揮発処理後に実施",
  },
];

function SelectVolatileComponentsHandling(props) {
  const { selectedValue, onSelect, isReadonly } = props;

  return (
    <div className="w-full h-full border border-solid border-[#B3B3B3] bg-white rounded-[10px]">
      <div className="w-full h-full flex flex-col items-center justify-center gap-2.5 p-2">
        <SelectOption
          label={volatileComponentsHandlingOptions[0].label}
          value={volatileComponentsHandlingOptions[0].value}
          onSelect={onSelect}
          isSelected={
            selectedValue === volatileComponentsHandlingOptions[0].value
          }
          isReadonly={isReadonly}
        />
        <SelectOption
          label={volatileComponentsHandlingOptions[1].label}
          value={volatileComponentsHandlingOptions[1].value}
          onSelect={onSelect}
          isSelected={
            selectedValue === volatileComponentsHandlingOptions[1].value
          }
          isReadonly={isReadonly}
        />
      </div>
    </div>
  );
}

export default SelectVolatileComponentsHandling;
